import React from 'react'

import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'

import {
    Container,
    Row,
    devices,
    colors,
} from '../Common'


export const Footer = () => {
    const { register, handleSubmit, errors } = useForm()
    // const { footerMessage, footerError } = useSelector(state => state.form, shallowEqual)
    const dispatch = useDispatch()
    const onSubmit = data => dispatch()

    const formOptions = { required: true }

    return (
        <FooterWrap>
            <FooterContainer>
                <FooterRow>
                    <FooterHeading>Contact Us</FooterHeading>
                    <FooterForm onSubmit={handleSubmit(onSubmit)}>
                        <FooterInput aria-label="name" name="name" type="text" placeholder="Name" ref={register(formOptions)} />
                        <FooterInput aria-label="email" name="email" type="email" placeholder="Email" ref={register(formOptions)} />
                        <FooterInput aria-label="subject" name="subject" type="text" placeholder="Subject" ref={register(formOptions)} />
                        <FooterTextarea aria-label="message" name="message" placeholder="Message" ref={register(formOptions)} />
                    </FooterForm>
                </FooterRow>
                <FooterRow>
                    <FooterHeading>Info</FooterHeading>
                    <Address>
                        626 West Cavalcade<br />
                        Houston, TX 77009<br />
                        Phone: <a href="tel:7138613331">713.861.3331</a><br />
                        <br />
                        Visit our warehouse
                    </Address>
                </FooterRow>
                <FooterRow>
                    <FooterHeading>Event form</FooterHeading>
                </FooterRow>
            </FooterContainer>
        </FooterWrap>
    )
}

const FooterWrap = styled.footer`
    padding-top: 50px;
    padding-bottom: 50px;
    width: 100%;
    background: ${colors.red};
    color: ${colors.white};
`

const Address = styled.div`
    a {
        text-decoration: none;
        color: ${colors.white};
    }
`

const FooterContainer = styled(Container)`
    max-width: 1400px;
    display: flex;
    justify-content: space-between;
`

const FooterHeading = styled.div`
    text-transform: uppercase;
    margin-bottom: 5px;
`

const FooterRow = styled(Row)`
    /* @media ${devices.mobile} { */
        flex-direction: column;
        justify-content: flex-start;
        padding: 0 20px;
    /* } */
`

// const FooterInfoWrap = styled.div`
//     width: calc(100% - 330px);
//     max-width: 540px;
//     padding-right: 60px;

//     @media ${devices.mobile} {
//         width: 100%;
//         max-width: 100%;
//         padding-right: 0;
//     }
// `

// const FooterMenu = styled.div`
//     width: 400px;
//     @media ${devices.mobile} {
//         width: 100%;
//         border-top: 1px solid ${colors.white};
//         padding-top: 20px;
//         margin-top: 20px;
//     }
// `

const FooterForm = styled.form`
    display: flex;
    flex-direction: column;
`

const FooterInput = styled.input`
    background: #CE2C3D;
    border: none;
    font-size: 25px;
    margin-bottom: 5px;
    outline: none;
    color: ${colors.white};
    padding: 10px;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
`

const FooterTextarea = styled.textarea`
    background: #CE2C3D;
    border: none;
    font-size: 25px;
    margin-bottom: 5px;
    color: ${colors.white};
    resize: none;
    outline: none;
    padding: 10px;
    height: 100px;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
`